<template>
    <section class="elle-page-elements">
        <component :is="eqTemplates[item.typeHandle]?.component || 'div'" v-for="item in data" :key="item.id" :settings="item" />
    </section>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        data?: CmsItem[];
    }>(),
    {
        data: () => []
    }
);

const data = computed(() => props.data);

const elBanner = resolveComponent('ElementsBanner');
const elBenefits = resolveComponent('ElementsBenefits');
const elPageHero = resolveComponent('ElementsPageHero');
const elIntro = resolveComponent('ElementsIntro');
const elIntroHero = resolveComponent('ElementsIntroHero');
const elInstagram = resolveComponent('ElementsInstagram');
const elLocationHero = resolveComponent('ElementsLocationHero');
const elHighlights = resolveComponent('ElementsHighlights');
const elMediaText = resolveComponent('ElementsMediaText');
const elInstructions = resolveComponent('ElementsInstructions');
const elPath = resolveComponent('ElementsPath');
const elRegister = resolveComponent('ElementsRegister');
const elReviews = resolveComponent('ElementsReviews');
const elSteps = resolveComponent('ElementsSteps');
const elSlider = resolveComponent('ElementsSlider');
const elTeam = resolveComponent('ElementsTeam');
const elToggle = resolveComponent('ElementsToggle');
const elFolders = resolveComponent('ElementsFolders');
const elLocationsList = resolveComponent('ElementsLocations');

const eqTemplates: Record<string, { component: ReturnType<typeof resolveComponent> }> = {
    benefits: {
        component: elBenefits
    },
    path: {
        component: elPath
    },
    frequentlyAskedQuestions: {
        component: elToggle
    },
    folders: {
        component: elFolders
    },
    instructions: {
        component: elInstructions
    },
    locationSlider: {
        component: elSlider
    },
    locationList: {
        component: elLocationsList
    },
    locationHero: {
        component: elLocationHero
    },
    teamSlider: {
        component: elSlider
    },
    teamGrid: {
        component: elTeam
    },
    textMedia: {
        component: elMediaText
    },
    reviews: {
        component: elReviews
    },
    intro: {
        component: elIntro
    },
    introHero: {
        component: elIntroHero
    },
    instagram: {
        component: elInstagram
    },
    sectionHero: {
        component: elPageHero
    },
    registration: {
        component: elRegister
    },
    professionals: {
        component: elHighlights
    },
    highlights: {
        component: elHighlights
    },
    steps: {
        component: elSteps
    },
    cta: {
        component: elBanner
    }
};
</script>
